import * as React from 'react';

const CompanyInfo = () => {
  return <>Company Info</>;
};

export default CompanyInfo;
